export default __webpack_public_path__ + "static/media/thumbnail2.c1075190.jpg";